import { buildingBlocksMarkupData } from './blocksData'
import { BuildingBlocksCard } from './BuildingBlocksCard'
import classes from './BuildingBlocks.module.scss'
import { Block } from 'ui-kit/blocks'

export const BuildingBlocks = () => {
  return (
    <Block variant={'shadow'} r='md' className={classes.wrapper}>
      <ul className={classes.list}>
        {buildingBlocksMarkupData.map((item, idx) => {
          return <BuildingBlocksCard key={idx} item={item} />
        })}
      </ul>
    </Block>
  )
}
